import { AdditionalInfoSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const AdditionalInfoSearchSchema: Yup.SchemaOf<AdditionalInfoSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    nationality: Yup.number().required().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { sex, fbiNumber } = this.parent;
            return !!value || !!sex || !!fbiNumber;
        }
    ),
    sex: Yup.number().required().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { nationality, fbiNumber } = this.parent;
            return !!value || !!nationality || !!fbiNumber;
        }
    ),
    fbiNumber: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { nationality, sex } = this.parent;
            return !!value || !!nationality || !!sex;
        }
    ),
});
